import {
  FlexibleBlockBrickSearch,
  FlexibleBlockBrickText,
  FlexibleBlockBrickTitle,
  FlexibleBlockProps,
  FlexibleBlockTemplateHeroSearch,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getHeroSearchBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateHeroSearch>[] => {
  const brickTitle: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Title',
    switchable: true,
    placeholder: 'Here, you can add title',
    text: 'Hello, everyone!',
    className: ['md:text-6xl', 'text-3xl', 'font-bold'],
    theme: { text: { main: PortalTextType.HERO_TEXT } },
  };

  const brickDescription: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Description',
    switchable: true,
    placeholder: 'Here, you can add description',
    text: 'We’re pleased to welcome you to Aeon Client portal – our hub for documents, project progress, and earnings',
    className: ['text-lg'],
    theme: { text: { main: PortalTextType.HERO_TEXT } },
  };

  const brickSearch: FlexibleBlockBrickSearch = {
    ...brickCommon,
    brickType: 'search',
    brickName: 'Search',
    switchable: true,
    placeholder: 'Search docs, tasks, files and other with AI',
    target: '_self',
    className: [],
  };

  let index = 0;
  return [
    {
      title: 'Headline & Search',
      template: { type: 'hero-search', view: 'basic' },
      bricks: [
        { ...brickTitle, index: index++ },
        { ...brickDescription, index: index++ },
        { ...brickSearch, index: index++ },
      ],
      className: ['justify-around', 'min-h-72', 'text-center'],
      wrapper: getWrapperProps('none'),
    },
  ];
};
